/**
 * OOTB file
*/
'use strict';
import wishlist from './wishlist/wishlist';
import giftCardDetail from './giftCard/giftCard';
import { queryFirst } from './domUtil';
import SwiperCarousel from './components/swiperCarousel';
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(wishlist);
    processInclude(giftCardDetail);

    SwiperCarousel.initCarousels(queryFirst('#wishlist'));
});
